import type { SVGProps } from 'react';

/** France — vertical blue/white/red tricolour. Decorative (`aria-hidden`); see `GbFlag` for sizing/crop notes. */
export const FrFlag = ({ width = '17', height = '12', ...props }: SVGProps<SVGSVGElement>) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 60 30"
        preserveAspectRatio="xMidYMid slice"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        {...props}>
        <rect width="60" height="30" fill="#fff" />
        <rect width="20" height="30" fill="#002395" />
        <rect x="40" width="20" height="30" fill="#ED2939" />
    </svg>
);
